import { useState, useEffect } from 'react';

export default function usePortalRoot() {
  const [root, setRoot] = useState<ShadowRoot | HTMLElement>();
  const [width, setWidth] = useState<number>();

  useEffect(() => {
    try {
      if (window === parent) throw new Error('Not in iframe');

      const container = document.createElement('div');
      parent.document.body.appendChild(container);

      const shadow = container.attachShadow({ mode: 'open' });

      Promise.all(
        Array.from(document.styleSheets)
          .filter(sheet => sheet.href)
          .map(sheet => {
            return new Promise<void>((resolve, reject) => {
              const link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = sheet.href!;
              link.onload = () => resolve();
              link.onerror = () => reject();
              shadow.appendChild(link);
            });
          })
      ).then(() => {
        setRoot(shadow);
      });

      function handleResize() {
        setWidth(container.clientWidth);
      }

      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(container);

      handleResize();

      return () => {
        resizeObserver.disconnect();
        window.parent.document.body.removeChild(container);
      };
    } catch (e) {
      setRoot(document.body);
    }
  }, []);

  return [root, width] as const;
}
